import React, { FunctionComponent, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next'
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { check_subdomain } from '../../lib/server_helper';
import { fetch_one } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';
// import { currentPracticeAtom } from '../../../lib/practice';


import {
  Avatar,
  Grid,
  Paper,
} from '@mui/material';

import {
  Button,
  Page,
  Typography
} from '../../../components/v2/styled';
import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';

// const { DateTime } = require("luxon");

type Props = {}

export const ClientThirdPartySynapse: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  // const queryClient = useQueryClient();
  // const { state } = useLocation();








  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: {
          success: boolean,
          error?: string
        }
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      if (!!data.custom_result.success) {
        window.open(`https://nutriportal.synapse-lifestyle.com/register?email=${login?.email}`, "_BLANK");
      }
    },
  });







  return <Page title={t("client.pages.3_party.synapse.title")}>
    <Paper sx={{
      padding: 2,
      marginTop: 2
    }}>
      <Grid container spacing={2} sx={{margin: 2}}>
        <Grid xs={12}>
          <Typography html>{t("client.pages.3_party.synapse.body")}</Typography>
        </Grid>
        <Grid xs={12} sx={{marginTop: 4}}>
          <Typography>{t("client.pages.3_party.synapse.connection_status")}</Typography>
          {!!login?.extra_data?.partner_ids?.synapse && <Typography><Avatar sx={{
            display: 'inline-flex',
            marginRight: 1,
            border: '1px solid transparent',
            borderColor: theme.palette.primary.main,
            backgroundColor: 'white'
          }}><Check sx={{color: theme.palette.primary.main}} /></Avatar>{t("client.pages.3_party.synapse.connection_status_connected")}</Typography>}
          {!login?.extra_data?.partner_ids?.synapse && <Typography><Avatar sx={{
            display: 'inline-flex',
            marginRight: 1,
            border: '1px solid transparent',
            borderColor: theme.palette.primary.main,
            backgroundColor: 'white'
          }}><Close sx={{color: theme.palette.primary.main}} /></Avatar>{t("client.pages.3_party.synapse.connection_status_unconnected")}</Typography>}
        </Grid>
        <Grid xs={12}>
          {!!login?.extra_data?.partner_ids?.synapse && <Button
            label={t("client.pages.3_party.synapse.cta_goto")}
            id='cta_goto'
            contained
            onClick={(v) => {
              window.open("https://nutriportal.synapse-lifestyle.com", "_BLANK");
            }}
          />}
          {!login?.extra_data?.partner_ids?.synapse && <Button
            label={t("client.pages.3_party.synapse.cta_connect")}
            id='cta_connect'
            contained
            loading={mutationCustomAction.isPending}
            onClick={(v) => {
              mutationCustomAction.mutate({
                formData: {
                  object: 'synapse',
                  class_action: 'custom_api_register'
                }
              });
            }}
          />}
        </Grid>
      </Grid>
    </Paper>
  </Page>;
}

